import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/masini-dacia-second-hand-fiabile-romania/")({
  head: () => routeHead("/masini-dacia-second-hand-fiabile-romania/"),
  beforeLoad: () => {
    throw redirect({ href: "/cars/dacia", statusCode: 301, replace: true });
  },
});
